import { REMOVE_MEDIA_ID } from 'actions';

export function removeMediaId(mediaId: string) {
  return { mediaId, type: REMOVE_MEDIA_ID };
}
